import { useState } from 'react'
import Api from 'portal-modules/common/api'

const usePrivacyPolicies = () => {
  const [cookieState, setCookieState] = useState({
    showEntrataPrivacyPolicy: false,
    entrataPrivacyPolicy: null,
  })

  const getAllPrivacyPolicies = async () => {
    const {
      privacy_policy,
      primary_privacy_policy,
      secondary_privacy_policy,
      show_entrata_privacy_policy,
    } = await Api.getPrivacyPolicies()

    if (!show_entrata_privacy_policy) {
      const privacyUrl =
        primary_privacy_policy && primary_privacy_policy.external_url
          ? primary_privacy_policy.external_url
          : secondary_privacy_policy &&
            secondary_privacy_policy.external_url &&
            secondary_privacy_policy.external_url

      window.open(privacyUrl, '_blank').focus()
    } else {
      setCookieState({
        ...cookieState,
        entrataPrivacyPolicy: privacy_policy,
        showEntrataPrivacyPolicy: true,
      })
    }
  }

  return {
    getAllPrivacyPolicies,
    cookieState,
    setCookieState,
  }
}

export default usePrivacyPolicies
